import { type RouteRecordRaw } from 'vue-router'

export const settingsRouterBrand: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () =>
          import('../components/brand/editors/general/BrandGeneralSettings.vue'),
        name: `brand.settings.general`,
        path: 'general',
      },
      {
        component: async () =>
          import('../components/brand/editors/BrandLinks.vue'),
        name: `brand.settings.links`,
        path: 'links',
      },
      {
        component: async () =>
          import('../components/brand/editors/UserNotifications.vue'),
        name: `brand.settings.user-notifications`,
        path: 'user-notifications',
      },
      {
        component: async () =>
          import('../components/brand/editors/BrandNotificationsEditor.vue'),
        name: `brand.settings.notifications`,
        path: 'notifications',
      },
      {
        component: async () =>
          import('../components/brand/editors/sms-marketing/SMSMarketingEditor.vue'),
        name: `brand.settings.sms-marketing`,
        path: 'sms-marketing',
      },
      {
        component: async () =>
          import('../components/brand/editors/automated-marketing/AutomatedMarketingSettings.vue'),
        name: `brand.settings.automated-marketing`,
        path: 'automated-marketing',
      },
      {
        component: async () =>
          import('../components/brand/editors/BrandFeatureToggles.vue'),
        name: `brand.settings.feature-toggles`,
        path: 'feature-toggles',
      },
    ].map((route) => ({
      ...route,
      meta: {
        locationRoute: 'location.settings.general',
        redirectToLocation: true,
      },
    })),
    component: async () => import('../views/BrandSettingsView.vue'),
    meta: {
      redirectToLocation: true,
      title: 'settings-brand',
    },
    name: 'brand.settings',
    path: 'settings',
    props: {
      pageName: 'settings',
    },
  },
]

const locationSettingsMeta = {
  brandRedirect: 'brand.settings.general',
  isLocationPage: true,
}

export const settingsRouterLocation: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () =>
          import('../components/location/editors/general/LocationGeneralSettingsEditor.vue'),
        meta: locationSettingsMeta,
        name: `location.settings.general`,
        path: 'general',
      },
      {
        component: async () =>
          import('../components/location/editors/AddressEditor.vue'),
        meta: locationSettingsMeta,
        name: `location.settings.address`,
        path: 'address',
      },
      {
        component: async () =>
          import('../components/location/editors/LocationLinks.vue'),
        meta: locationSettingsMeta,
        name: `location.settings.links`,
        path: 'links',
      },
      {
        component: async () =>
          import('../components/location/editors/ContactInfoEditor.vue'),
        meta: locationSettingsMeta,
        name: `location.settings.contact`,
        path: 'contact',
      },
      {
        component: async () =>
          import('../components/location/editors/notifications/NotificationsEditor.vue'),
        meta: locationSettingsMeta,
        name: `location.settings.notifications`,
        path: 'notifications',
      },
      {
        component: async () =>
          import('../components/location/editors/fulfillment/FulfillmentEditorSwitch.vue'),
        meta: locationSettingsMeta,
        name: `location.settings.fulfillment`,
        path: 'fulfillment',
      },
      {
        component: async () =>
          import('../components/location/editors/integrations/IntegrationsEditor.vue'),
        meta: locationSettingsMeta,
        name: `location.settings.integrations`,
        path: 'integrations',
      },
      {
        component: async () =>
          import('../components/location/editors/FeesEditor.vue'),
        meta: locationSettingsMeta,
        name: `location.settings.fees`,
        path: 'fees',
      },
      {
        component: async () =>
          import('../components/location/editors/FeaturesEditor.vue'),
        meta: locationSettingsMeta,
        name: `location.settings.features`,
        path: 'features',
      },
      {
        component: async () =>
          import('../components/location/editors/ListingsEditor.vue'),
        meta: { ...locationSettingsMeta, roles: ['pb:super'] },
        name: `location.settings.listings`,
        path: 'listings',
      },
    ],
    component: async () => import('../views/LocationSettingsView.vue'),
    meta: {
      authZ: ({ user }) => user.can('update', 'location'),
      permissions: [{ operation: 'update', resource: 'location' }],
      scopes: ['locations:update'],
      title: 'settings',
    },
    name: `location.settings`,
    path: 'settings',
  },
]
